import React from "react";
import PolicyPage from "@/pages/PolicyPage";

export default function TermsOfService() {
  return (
    <PolicyPage
      title="Terms of Service"
      sections={[
        {
          paragraphs: [
            "By using the T&J Clinical Solutions website or submitting a service request, users agree to the company's policies, procedures, and operational terms.",
          ],
        },
        {
          heading: "Appointment Confirmation",
          paragraphs: [
            "Submitting a request does not guarantee appointment availability until confirmation is provided by T&J Clinical Solutions.",
          ],
        },
        {
          heading: "Service Availability",
          paragraphs: ["Service availability may vary depending on:"],
          bullets: [
            "staffing",
            "travel distance",
            "timing",
            "scheduling capacity",
            "operational limitations",
          ],
        },
        {
          heading: "Our Rights",
          paragraphs: ["T&J Clinical Solutions reserves the right to:"],
          bullets: [
            "decline requests",
            "reschedule appointments",
            "adjust pricing",
            "modify operational procedures when necessary",
          ],
        },
        {
          heading: "Client Responsibilities",
          paragraphs: [
            "Clients are responsible for providing accurate contact and appointment information.",
          ],
        },
        {
          heading: "Agreement to Policies",
          paragraphs: [
            "Use of the website and services constitutes agreement with all posted policies.",
          ],
        },
      ]}
    />
  );
}
